jQuery.fn.extend( {
	unwrapInner: function ( selector ) {
		return this.each( function () {
			var t = this,
				c = $( t ).children( selector );

			if ( c.length > 0 ) {
				c.each( function () {
					$( this ).contents().appendTo( t );
					$( this ).remove();
				} );
			}
		} );
	}
} );


SubitoTexto.splitText = function ( $selector ) {
	var $ = jqPla,
		splitClass = 'split-text-block',
		testClass = 'split-text-test-split',
		$foundSplits = $selector.find( splitClass );


	$selector.parents( '.article-title' ).addClass( 'calculating' );

	if ( $foundSplits.length > 0 ) {
		$selector.unwrapInner( '.' + splitClass );
	}


	var allText = $selector.text(),
		arrTexts = allText.trim().split( ' ' );

	if ( arrTexts.length < 2 ) {
		return false;
	}


	var htmlAllSplits = '';
	for ( var i = 0; i < arrTexts.length; i++ ) {

		htmlAllSplits += '<span class="' + testClass + '">' + arrTexts[ i ] + ' </span>';

	}

	$selector.html( htmlAllSplits );


	var $testSplits = $selector.find( '.' + testClass ),
		currStart = 0,
		currY,
		lastY = $testSplits.eq( 0 ).position().top,
		htmlOut = '';


	$testSplits.each( function ( i, el ) {

		var $currSplit = $( this );

		currY = $currSplit.position().top;

		//console.log( i, $currSplit, currStart, currY, lastY );

		if ( currY > lastY ) {
			var tempGroup = '';
			for ( var j = currStart; j < i; j++ ) {
				tempGroup += $testSplits.eq(j).html();
			}

			htmlOut += '<div class="' + splitClass + '">' + tempGroup + '</div>';

			currStart = i;
			lastY = currY;
		}

	} );

	var tempGroup = '';
	for ( var j = currStart; j < $testSplits.length; j++ ) {
		tempGroup += $testSplits.eq(j).html();
	}
	htmlOut += '<div class="' + splitClass + '">' + tempGroup + '</div>';

	$selector.html(htmlOut);

	// last group
	//$testSplits.slice( currStart, i ).wrapAll( '<div class="' + splitClass + '" />' );


	$selector.find( '.' + splitClass ).each( function ( i, el ) {
		//	$( this ).unwrapInner( '.' + testClass );
	} );


	$selector.parents( '.article-title' ).removeClass( 'calculating' ).addClass( 'calculated' );

}